module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-alt-low-7df2c7e3.svg";